import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { Tab, Tabs } from '@/components/elements/Button/TabButton';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

const CustomTabs = styled(Tabs)(() =>
  mq({
    display: ['grid', 'grid', 'grid', 'grid'],
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: [
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
    ],
    padding: [
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
    ],
    margin: [
      `0 ${defaultTheme.spacing.l} ${defaultTheme.spacing.l}`,
      `0 ${defaultTheme.spacing.l} ${defaultTheme.spacing.l}`,
      `0 0 ${defaultTheme.spacing.xxl}`,
      `0 0 ${defaultTheme.spacing.xxl}`,
    ],
  }),
);

export const Navi = styled.nav(() =>
  mq({
    width: '100%',
    maxWidth: '840px',
  }),
);

export const TabList = CustomTabs.withComponent('ul');

export const CustomTab = styled(Tab)(() =>
  mq({
    flex: '1 0 auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: [
      defaultTheme.font.size.xs,
      defaultTheme.font.size.xs,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
    lineHeight: defaultTheme.font.height.m,
    wordBreak: 'keep-all',
    padding: ['0', '0', '0', '0'],
    height: ['46px', '46px', '48px', '48px'],
    width: '100%',
  }),
);

export const StyledLink = styled(Link)(() =>
  mq({
    display: 'block',
  }),
);

export const SignupBox = styled.div(() =>
  mq({
    marginTop: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
    ],
  }),
);
